"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomCheckbox = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.CustomCheckbox = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  min-width: 1rem;\n  height: 1rem;\n  border: 0.0625rem solid\n    ", ";\n  border-radius: ", ";\n"], ["\n  min-width: 1rem;\n  height: 1rem;\n  border: 0.0625rem solid\n    ", ";\n  border-radius: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["400"]', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS.SMALL', theme);
});
var templateObject_1;
//# sourceMappingURL=custom-checkbox.js.map